.state {
  padding-block: var(--hcr-spacing-4);
  color: var(--hcr-content-secondary-color);
}

.banner {
  margin-block-end: var(--hcr-spacing-4);
}
